import React from 'react';
import { AgentConversation as DumAgentConversation } from '../../components/agent-conversation/agent-conversation';

type AgentConversationProps = {
  id: string;
};

export const AgentConversation = ({ id }: AgentConversationProps) => {
  return (
    <>
      <div className="mt-4">
        <DumAgentConversation agentId={id} />
      </div>
    </>
  );
};
